export default "__VITE_ASSET__BCCTC9Te__"